
const VideoMessage = ({ message }) => {
  return (
    <span>
    <video controls className="max-w-full rounded-lg"><source src={message?.media?.file} type="video/mp4" /></video>
        {message?.message && <div className="mt-2">{message?.message}</div>}
        </span>
  );
};

export default VideoMessage;
